import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";
var _IconPlayLine;
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { createRoot } from 'react-dom/client';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { Flex } from '@instructure/ui-flex';
import { CondensedButton } from '@instructure/ui-buttons';
import { IconPlayLine } from '@instructure/ui-icons';
import formatMessage from '../format-message';
const YoutubeEmbedOverlay = ({
  iframeElement,
  height,
  width
}) => {
  const [showOverlay, setShowOverlay] = useState(true);
  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current && iframeElement) {
      if (width) {
        containerRef.current.style.width = `${width}px`;
      }
      if (height) {
        containerRef.current.style.height = `${height}px`;
      }
      containerRef.current.appendChild(iframeElement);
    }
  }, [height, iframeElement, width]);
  const handleCloseOverlay = useCallback(() => {
    setShowOverlay(false);
  }, [setShowOverlay]);
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    position: "relative",
    display: "inline-block"
  }, void 0, showOverlay && /*#__PURE__*/_jsx(View, {
    as: "div",
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "primary",
    themeOverride: {
      backgroundPrimary: 'rgba(10, 71, 91, 0.65)'
    },
    overflowY: "hidden"
  }, void 0, /*#__PURE__*/_jsx(Flex, {
    justifyItems: "center",
    height: "100%"
  }, void 0, /*#__PURE__*/_jsx(Flex.Item, {
    shouldShrink: true,
    shouldGrow: true,
    textAlign: "center"
  }, void 0, /*#__PURE__*/_jsx(Flex, {
    justifyItems: "center",
    margin: "0 0 small"
  }, void 0, /*#__PURE__*/_jsx(Flex.Item, {}, void 0, /*#__PURE__*/_jsx(Text, {
    color: "secondary-inverse",
    weight: "bold"
  }, void 0, formatMessage('This video may display YouTube ads.')))), /*#__PURE__*/_jsx(Flex, {
    justifyItems: "center",
    margin: "0 0 medium"
  }, void 0, /*#__PURE__*/_jsx(Flex.Item, {}, void 0, /*#__PURE__*/_jsx(CondensedButton, {
    "data-test-id": "youtube-migration-close-overlay",
    color: "primary-inverse",
    onClick: handleCloseOverlay
  }, void 0, _IconPlayLine || (_IconPlayLine = /*#__PURE__*/_jsx(IconPlayLine, {})), "\xA0", formatMessage('Continue to YouTube content'))))))), /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }));
};
export const createOverlay = iframes => {
  iframes.forEach(iframe => {
    const iframeElement = iframe;
    const height = iframeElement.offsetHeight;
    const width = iframeElement.offsetWidth;
    const container = document.createElement('div');
    container.setAttribute('data-test-id', 'youtube-migration-container');
    iframe.replaceWith(container);
    createRoot(container).render(/*#__PURE__*/_jsx(YoutubeEmbedOverlay, {
      iframeElement: iframeElement,
      height: height,
      width: width
    }));
  });
};